import { render, staticRenderFns } from "./ModelPartTile.vue?vue&type=template&id=132a050c&scoped=true&"
import script from "./ModelPartTile.vue?vue&type=script&lang=js&"
export * from "./ModelPartTile.vue?vue&type=script&lang=js&"
import style0 from "./ModelPartTile.vue?vue&type=style&index=0&id=132a050c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a050c",
  null
  
)

export default component.exports